export default __webpack_public_path__ + "static/media/16-video-logic.2867a293.jpg";